import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgIconBook = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 17,
	viewBox: "0 0 16 17",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		id: "Vector",
		d: "M11.9998 1.83333H3.99984C3.2665 1.83333 2.6665 2.43333 2.6665 3.16666V13.8333C2.6665 14.5667 3.2665 15.1667 3.99984 15.1667H11.9998C12.7332 15.1667 13.3332 14.5667 13.3332 13.8333V3.16666C13.3332 2.43333 12.7332 1.83333 11.9998 1.83333ZM3.99984 3.16666H7.33317V8.5L5.6665 7.5L3.99984 8.5V3.16666Z",
		fill: "white"
	})
});
export default SvgIconBook;
